import { render } from "./C_Reg.vue?vue&type=template&id=0371f4f2&scoped=true"
import script from "./C_Reg.vue?vue&type=script&lang=js"
export * from "./C_Reg.vue?vue&type=script&lang=js"

import "./C_Reg.vue?vue&type=style&index=0&id=0371f4f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0371f4f2"]])

export default __exports__